<mat-radio-group class="ds-radio-group" [value]="value" [disabled]="isDisabled" (change)="onGroupChange($event.value)">
    <div
        class="ds-radio-group__option stagger-item"
        *ngFor="let option of options; trackBy: trackByRadioGroupOptionValue"
        [ngClass]="[
            'ds-radio-group__option--' + size,
            option.disabled || isDisabled ? 'ds-radio-group__option--disabled' : '',
            value === option.value ? 'ds-radio-group__option--checked' : '',
            option.subtitle ? 'ds-radio-group__option--with-subtitle' : '',
        ]"
        [attr.tabindex]="option.disabled || isDisabled ? -1 : 0"
        (click)="onOptionSelect(option)"
        (keyup.enter)="onOptionSelect(option)"
        (keyup.space)="onOptionSelect(option)"
    >
        <mat-radio-button class="ds-radio-group__item" [value]="option.value" [disabled]="!!option.disabled || isDisabled" disableRipple>
            {{ option.label }}
        </mat-radio-button>

        <p *ngIf="option.subtitle" class="ds-radio-group__subtitle">{{ option.subtitle }}</p>
    </div>
</mat-radio-group>
